import { MapGroupId } from "../../types";
import img from "../../mapImages/ReserveMain3D.webp";

const mapData = {
  groupId: MapGroupId.Reserve,
  groupName: {
    en: "Reserve",
    ru: "Резерв ",
  },
  title: {
    en: "Main 3D",
    ru: "Главная 3D",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
